// Chapter 9 writing frames ("מסגרות"), uploaded 1.11.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch9_fN"> in src/chapters/chapter-9.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH9_FRAMES: Frame[] = [
  {
    "id": "ch9_f1",
    "n": "9.1",
    "title": "השיחה שלי",
    "type": "lines",
    "intro": "עובדות בלבד, בלי שיפוט. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי לה:",
      "עם מי, ועל מה (מה שמצלמה הייתה רואה):",
      "מה הרגשתי בסוף השיחה, ובאיזו עוצמה (1-10):",
      "הכלי שהתעורר אצלי ראשון:"
    ]
  },
  {
    "id": "ch9_f2",
    "n": "9.2",
    "title": "כמה הקשבתי",
    "type": "scale2",
    "intro": "1 = דיברתי כל הזמן, 10 = הקשבתי כמעט כל הזמן.",
    "fields": [
      "כמה הקשבתי בשיחה שלי",
      "מה שפת הגוף שלו או שלה אמרה, ולא שמעתי:",
      "השאלה האחת שהייתי יכולה לשאול:"
    ]
  },
  {
    "id": "ch9_f3",
    "n": "9.3",
    "title": "מאיפה זה בא לי",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה בשיחה הקפיץ אותי מעבר לפרופורציה:",
      "למה זה כנראה מתחבר אצלי (ניחוש, לא חייב להיות מדויק):",
      "משפט הקבלה שלי, במילים שלי:"
    ]
  },
  {
    "id": "ch9_f4",
    "n": "9.4",
    "title": "נקודת העצירה שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "המשפט שלפני המשפט שאני מצטערת עליו (שם הייתה נקודת העצירה):",
      "מה הייתי שומעת בחצי דקה של שתיקה:",
      "המילה או התנועה שתזכיר לי לעצור בפעם הבאה:"
    ]
  },
  {
    "id": "ch9_f5",
    "n": "9.5",
    "title": "האיום שמתחת לשיחה",
    "type": "choice5",
    "intro": "סמני אחד, ואז שורה אחת:",
    "fields": [
      "פרנסה · מעמד או הערכה · קשרים ושייכות · שליטה · אף אחד מאלה",
      "האיום במילים שלי, והאם הוא אמיתי:"
    ]
  },
  {
    "id": "ch9_f6",
    "n": "9.6",
    "title": "הסימן המוקדם שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה הגוף שלי עשה בשיחה לפני שהבנתי שאני בלחץ:",
      "הסימן המוקדם שלי, במילה אחת (הסימן שכתבת בפרק 3 - עדיין אותו, או שהפעם הגיע סימן אחר?):",
      "דבר אחד טוב מאותו יום, ועם מי אשתף אותו:"
    ]
  },
  {
    "id": "ch9_f7",
    "n": "9.7",
    "title": "אחרי השיחה: לבד, או בודדה",
    "type": "choice5",
    "intro": "סמני אחד, ואז שורה אחת:",
    "fields": [
      "לבד, ונעים · לבד, ובודדה · בודדה גם בין אנשים · לא נשארתי לבד בכלל",
      "מה הפך את הלבד לבדידות (או להפך), ודבר אחד שאני נהנית לעשות לבד:"
    ]
  },
  {
    "id": "ch9_f8",
    "n": "9.8",
    "title": "ההגה שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "מי אחז בהגה בשיחה שלי (אני / הוא או היא / הרגש):",
      "מה באמת רציתי שייצא ממנה:",
      "הצעד הקטן שלי השבוע לכיוון הזה:"
    ]
  },
  {
    "id": "ch9_f9",
    "n": "9.9",
    "title": "נקודת אי-ההבנה",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "מה אני התכוונתי|מה הוא או היא כנראה שמעו",
      "אי-הבנה או אי-הסכמה, ונקודת אי-ההבנה במשפט אחד:"
    ]
  },
  {
    "id": "ch9_f10",
    "n": "9.10",
    "title": "החבל והשאלה",
    "type": "lines",
    "intro": "",
    "fields": [
      "החבל שאמשוך בו (מילה או משפט שהוא או היא אמרו, ואבקש עוד):",
      "השאלה האחת שלי, ואחריה שתיקה:",
      "כמה דקות אני מוכנה רק להקשיב:"
    ]
  },
  {
    "id": "ch9_f11",
    "n": "9.11",
    "title": "השיחה שלי, פעם שנייה",
    "type": "final",
    "intro": "",
    "fields": [
      "כמה מהרגש של השיחה נשאר בי עכשיו (1-10):",
      "האופציה שאני בוחרת: פרשנות אחרת / מקור אחר להרגשה טובה / מדיטציה:",
      "השיחה שלי, פעם שנייה (שלוש שורות):",
      "",
      "",
      "מתי אני פותחת אותה שוב, ותאריך:"
    ]
  }
];
